export default "__VITE_ASSET__8f6785d5__"